import { render, staticRenderFns } from "./SagaCard.vue?vue&type=template&id=2a5cf70d&scoped=true&"
import script from "./SagaCard.vue?vue&type=script&lang=js&"
export * from "./SagaCard.vue?vue&type=script&lang=js&"
import style0 from "./SagaCard.vue?vue&type=style&index=0&id=2a5cf70d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5cf70d",
  null
  
)

export default component.exports